import {
  PhoneInputButtonStyle,
  PhoneInputTextAreaStyle,
} from 'containers/Contact/stylesProperties';
import { useForm } from 'react-hook-form';
import { ContactUsScheme } from 'validationSchemes';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { contactAction, POST_CONTACT } from 'store/contactUs';
import { LoadingButton } from 'components';
import { useFindLoad } from 'hooks/useFindLoad';
import { useFindSuccess } from 'hooks/useFindSuccess';
import {
  ButtonBlock,
  Form,
  FormMainWrapper,
  InfoFromUserInput,
  MessageInput,
  PhoneFromUserInput,
  QuoteBlock,
  StyledErrorMessage,
  StyledFlexContainer,
  UserInformationContainer,
  UserMessageContainer,
} from './styled';

export const InputSection = () => {
  const [phoneNumber, setPhoneNumber] = useState(0);
  const [isPhoneNumberValidation, setIsPhoneNumberValidation] = useState(false);

  const isLoading = useFindLoad(POST_CONTACT);

  const isSuccess = useFindSuccess(POST_CONTACT);

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(ContactUsScheme),
  });

  const handleChange = (e) => {
    let phoneNumber = e?.target?.value;
    if (phoneNumber === undefined) {
      phoneNumber = 0;
    }

    if (phoneNumber[1]) {
      setPhoneNumber(phoneNumber);
    }

    const phone = String(phoneNumber).split(' ');
    if (phone[2]?.length >= 3) {
      setIsPhoneNumberValidation(false);
    } else {
      setIsPhoneNumberValidation(true);
    }
  };

  const handlePhoneNumber = () => {
    const phone = String(phoneNumber).split(' ');

    if (phone[2]?.length >= 3) {
      setIsPhoneNumberValidation(false);
    } else {
      setIsPhoneNumberValidation(true);
    }
  };

  const onSubmit = (data) => {
    const phone = String(phoneNumber).split(' ');

    if (phone[2]?.length >= 3) {
      setIsPhoneNumberValidation(false);
    } else {
      setIsPhoneNumberValidation(true);
    }

    const { lastName, firstName, email, description } = data;

    if (phoneNumber !== 0) {
      const body = {
        last_name: lastName,
        first_name: firstName,
        phone_number: phoneNumber,
        email,
        description,
      };
      dispatch(contactAction.postContact(body));
    }
  };

  useEffect(() => {
    if (isSuccess.length) {
      reset();
      setPhoneNumber();
    }
  }, [isSuccess?.length]);

  return (
    <FormMainWrapper>
      <QuoteBlock>We'd love to hear from you!</QuoteBlock>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <UserInformationContainer>
          <StyledFlexContainer>
            <InfoFromUserInput
              autoComplete="off"
              {...register('firstName')}
              placeholder="First Name"
              error={errors.firstName?.message}
            />
            <StyledErrorMessage>{errors.firstName?.message}</StyledErrorMessage>
          </StyledFlexContainer>

          <StyledFlexContainer>
            <InfoFromUserInput
              autoComplete="off"
              {...register('lastName')}
              placeholder="Last name"
              error={errors.lastName?.message}
            />
            <StyledErrorMessage>{errors.lastName?.message}</StyledErrorMessage>
          </StyledFlexContainer>

          <StyledFlexContainer>
            <PhoneFromUserInput
              country={'us'}
              placeholder="Phone Number"
              error={isPhoneNumberValidation}
              inputProps={{
                autoComplete: 'off',
                name: 'phoneNumber',
              }}
              value={phoneNumber}
              onChange={(value, country, e) => handleChange(e)}
              inputStyle={PhoneInputTextAreaStyle}
              buttonStyle={PhoneInputButtonStyle}
            />
            {isPhoneNumberValidation ? (
              <StyledErrorMessage>Invalid Phone Number</StyledErrorMessage>
            ) : null}
          </StyledFlexContainer>

          <StyledFlexContainer>
            <InfoFromUserInput
              autoComplete="off"
              {...register('email')}
              placeholder="Email Address"
              type="text"
              error={errors.email?.message}
            />
            <StyledErrorMessage>{errors.email?.message}</StyledErrorMessage>
          </StyledFlexContainer>
        </UserInformationContainer>

        <UserMessageContainer>
          <MessageInput
            autoComplete="off"
            {...register('description')}
            placeholder="Message"
            error={errors.description?.message}
          />
          <StyledErrorMessage>{errors.description?.message}</StyledErrorMessage>

          <ButtonBlock onClick={handlePhoneNumber}>
            <LoadingButton
              width="218px"
              height="54px"
              loading={isLoading}
              name="Send Message"
              type="submit"
            />
          </ButtonBlock>
        </UserMessageContainer>
      </Form>
    </FormMainWrapper>
  );
};
